export const PLACEHOLDERS = {
  SUBJECT: 'subject',
  TITLE: 'title',
  TEMPLATE: 'template',
  TINY_URL: 'tinyUrl',
  MEDIA: 'media',
  WEB_FORM_CTA: 'webFormCTA',
  CALLBACK: 'callback',
  DYNAMIC_CTA: 'dynamicCTA',
  FORM: 'form',
  URL: 'url',
  CARD: 'card',
  RECIPIENT_ID: 'recipientId',
  ADDITIONAL_PARAM: 'additionalParam',
};
export const CHANNEL_PLACEHOLDER_MAPPER = {
  sms: [
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.TINY_URL,
    PLACEHOLDERS.FORM,
    PLACEHOLDERS.URL,
    PLACEHOLDERS.RECIPIENT_ID,
  ],
  whatsapp: [
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.TINY_URL,
    PLACEHOLDERS.FORM,
    PLACEHOLDERS.URL,
    PLACEHOLDERS.CARD,
    PLACEHOLDERS.WEB_FORM_CTA,
    PLACEHOLDERS.DYNAMIC_CTA,
    PLACEHOLDERS.CALLBACK,
    PLACEHOLDERS.MEDIA,
  ],
  rcs: [
    PLACEHOLDERS.TITLE,
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.TINY_URL,
    PLACEHOLDERS.MEDIA,
    PLACEHOLDERS.WEB_FORM_CTA,
    PLACEHOLDERS.CALLBACK,
    PLACEHOLDERS.DYNAMIC_CTA,
    PLACEHOLDERS.FORM,
    PLACEHOLDERS.URL,
    PLACEHOLDERS.CARD,
  ],
  email: [
    PLACEHOLDERS.SUBJECT,
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.TINY_URL,
    PLACEHOLDERS.FORM,
    PLACEHOLDERS.URL,
  ],
  ['push notification']: [
    PLACEHOLDERS.TITLE,
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.ADDITIONAL_PARAM,
    PLACEHOLDERS.RECIPIENT_ID,
  ],
  whatsapp_cards: [
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.MEDIA,
    PLACEHOLDERS.WEB_FORM_CTA,
    PLACEHOLDERS.DYNAMIC_CTA,
    PLACEHOLDERS.FORM,
    PLACEHOLDERS.URL,
  ],
  RCS_cards: [
    PLACEHOLDERS.TITLE,
    PLACEHOLDERS.TEMPLATE,
    PLACEHOLDERS.TINY_URL,
    PLACEHOLDERS.MEDIA,
    PLACEHOLDERS.WEB_FORM_CTA,
    PLACEHOLDERS.CALLBACK,
    PLACEHOLDERS.DYNAMIC_CTA,
    PLACEHOLDERS.FORM,
    PLACEHOLDERS.URL,
  ],
};
